import axios from 'axios';
import { editRouteQuery } from './queries';

const editTrailer = (model, key) =>
    new Promise((resolve, reject) => {
        const query = editRouteQuery({ key, model });
        const request = axios.patch(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to edit route'));
            });
    });

export default editTrailer;
